import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { BITBUCKET_APP_MODEL_VERSION, BitbucketLinkedService } from 'app/model/linkedservice/bitbucket.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BitbucketLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            version: '*',
            typeProperties: {
                host: '*',
                accessToken: 'secret'
            },
            parameters: '*'
        }
    }
})
export class BitbucketLinkedServiceAdapter extends LinkedServiceAdapter<BitbucketLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => BitbucketLinkedService {
        return BitbucketLinkedService;
    }

    protected model(): IModel {
        return BitbucketLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        linkedService: BitbucketLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.BitbucketLinkedService;
        properties.type = Metamodel.modelFor(BitbucketLinkedService).name;
        properties.version = BITBUCKET_APP_MODEL_VERSION;
        properties.typeProperties = {
            host: ValueAdapter.toResource(linkedService, BitbucketLinkedService.HOST),
            accessToken: parameterizablePasswordOrAKVtoSecretBase(
                linkedService,
                BitbucketLinkedService.ACCESS_TOKEN,
                this.context
            )
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: BitbucketLinkedService
    ): Promise<BitbucketLinkedService> {
        const properties = linkedServiceResource.properties as Model.BitbucketLinkedService;
        linkedService.version = properties.version ?? BITBUCKET_APP_MODEL_VERSION;
        ValueAdapter.toModel(linkedService, BitbucketLinkedService.HOST, properties.typeProperties.host);
        parameterizableSecretBaseToModel(
            linkedService,
            BitbucketLinkedService.ACCESS_TOKEN,
            properties.typeProperties.accessToken,
            this.context
        );
        return linkedService;
    }
}
